// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"187":"search","773":"view-pdf"}[chunkId] + "." + {"187":"80bd0931","773":"63b1083f"}[chunkId] + ".css";
};